import {useState}  from 'react';
import NormalIcon from '../StockItems/NormalIcon';
import NormalBtn from '../StockItems/NormalBtn';
import * as CoreFns from '../utilities/CoreFns';
// import * as SharedAcross from '../utilities/SharedAcross';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as ServerComms from '../utilities/ServerComms';
import VerifyContract from './VerifyContract';

function App(props) {

  var signKey = props.signKey;
  var userID = props.userID;
  var logInState = props.logInState;
  var sessionID = props.sessionID;
  var chainId = props.chainId;
  var smartContracts = props.smartContracts;
  var updateExistingSCWithNewChain = props.updateExistingSCWithNewChain;
  var addNewSc = props.addNewSc;
  var deleteSc = props.deleteSc;
  // var updateProxy = props.updateProxy;
  // var deleteProxy = props.deleteProxy;
  var tempAddr = props.tempAddr;
  var setTempAddr = props.setTempAddr;
  var addToExtraScreen = props.addToExtraScreen;
  var organicChanges = props.organicChanges;
  var chains = props.chains;

  var chainName = CoreFns.chainNameFromId(chainId, chains);
  var color = 'white';
  var scKeys = Object.keys(smartContracts);

  const [amendingWhat, setAmendingWhat] = useState(false);
  const [uploadErrorMsgs, setUploadErrorMsgs] = useState({});
  const [whichSc, setWhichSc] = useState('');


  function getAddSetName(aScKey){
    return getAddSetItem(aScKey, 'contractName');
  }

  function getAddSetItem(aScKey, item){
    var addSet = smartContracts[aScKey].addSet;
    var addSetKeys = Object.keys(addSet);
    return addSet[addSetKeys[0]][item];
  }


    function handleAnAmending(title){
  //
      var button;
      if (uploadErrorMsgs[amendingWhat]){
        var loc = CoreFns.getRelevantChain(chainId, chains).l;
        var locOut = loc + tempAddr + '#code';

        button = <div>Contract source code not verified. Please go to <a href={locOut} target='_blank'>{locOut}</a> to upload the source code<br/><br/>
        </div>
  //      
      }

        function clickExisting(e){
          addToExtraScreen({t:'existingSmartContractsOfChain'});
        }

      var fromSource = <div style={{cursor:'pointer', color:'#CCC'}} onClick={clickExisting}>[Select from contract created on Cues.sg]</div>
//
      function doClickCancel(e){
        clickCell('', '')
      }

      // function postEffects(thisItem){
      //   var alreadyGot = false;
      //   contractKeys.forEach((aContractKey, index)=>{
      //     var thisContract = contracts[aContractKey];
      //     if (thisContract.addr === liveContractAddress && thisContract.chainId === chainId){
      //       alreadyGot = true;
      //     }
      //   })

      //   if (alreadyGot){
      //     window.alert('Contract has already been added');
      //   }else{
      //     var uuid = CoreFns.uuidScoped(userNos, currentList, path, []);
      //     var newPiece = {contractName:thisItem.ContractName, addr:liveContractAddress, abi:thisItem.ABI, chainId};
      //     var changes = [{t:'w',w:path.concat([uuid]), n:newPiece}];
      //     organicChanges(changes);
      //   }
      //   setLiveContractAddress('');
      // }


      function doPost(thisItem){
          setAmendingWhat(false);
          var n = {addr:tempAddr, contractName:thisItem.ContractName, abi:thisItem.ABI};

          if (thisItem.ABI === 'Contract source code not verified'){
              window.alert('This contract\'s source code has not been verified');
              return;
            }



          if (whichSc !== 'load'){
            updateExistingSCWithNewChain(whichSc, n);
          }else{
            addNewSc(n);
          }
          setWhichSc('');        
      }

      var top = <div className='col-12 mx-auto text-center' style={{color}}>
          <b><u>{title}</u></b><br/>
          <input autoFocus className='inputBoxClassLong' value={tempAddr} onChange={onChange} onKeyDown={onInputKeyDown} style={{width:'80%'}} placeholder='Type in contract address (e.g. 0xFe298aE62C084FC74f2CAA0A7E0F0684D9311Cd0)' /><br/>
        {button}
        {fromSource}
        <VerifyContract tempAddr={tempAddr} postEffects={doPost} signKey={signKey} userID={userID} sessionID={sessionID} chainId={chainId} chains={chains} /><br/><br/>
        <NormalBtn icon='clarity:cancel-line' backScreen={true} title='Cancel' onClick={doClickCancel} />
        </div>
//
        return [top]

    }
  //
    function clickDeleteSC(aScKey){
      return function(e){
        deleteSc(aScKey);
        setTempAddr('');
        setAmendingWhat(false);
        setWhichSc('');
      }
    }

    function changeAddSetName(aScKey, name){
      return function(e){
        var p = window.prompt('What would you like to call this contract?', name);
        if (p){
          var pI = p.split(' ').join('');
          var regex3 = /^[a-zA-Z][a-zA-Z0-9]*$/
          if (pI.match(regex3)){
            var addSet = smartContracts[aScKey].addSet;
            var addSetKeys = Object.keys(addSet);
            var changes = [{t:'w', w:['sc', aScKey, 'addSet', addSetKeys[0], 'contractName'],n:pI}];
            organicChanges(changes);
          }else{
            window.alert('Contract name cannot start with a number');
          } 

        }
        e.stopPropagation();
      }
    }

    var rows = scKeys.map((aScKey, index)=>{
      var anAddSetName = getAddSetName(aScKey);

      var currAddress = getAddSetItem(aScKey, 'addr');
      var currAddressShort = StyleFunctions.shortenName(currAddress);

        var txtBit = null;
        var col = color;

        // if (error){
        //   var path = error.screenPath;
          // if (path[0] === 'sc' && path[1] === aScKey){
        var thisSc = smartContracts[aScKey];
        if (thisSc){
          var addSetHere = thisSc.addSet;
          var addSetHereKeys = Object.keys(addSetHere);
          var firstKey = addSetHereKeys[0];
          if (+firstKey !== chainId){ 
            var chainNameHere = CoreFns.chainNameFromId(+firstKey, chains);
            txtBit = anAddSetName + ' Contract ('+currAddressShort+') is on the ' + chainNameHere + ' chain, not the ' + chainName + ' which is the current chain selected.';
          }
          if (!txtBit && thisSc.template){
            txtBit = anAddSetName + ' Contract is the contract provided by the template and has not been modified.'          
          }
        }

        if (!txtBit){
          txtBit = currAddressShort;
        }

        var origAbi = getAddSetItem(aScKey, 'abi');
        function getFunctionsBit(abiPieces){
          return abiPieces.filter((aAbiLine, index)=>{
            return aAbiLine.type === 'function';
          }).map((aAbiLine, index)=>{
            return aAbiLine.name;
          }).join(', ')

        }

        if (origAbi === 'Contract source code not verified'){
          return <div className='col-4' >Unverified contract<NormalIcon title='Delete' isBrightWhenLit={true} onClick={clickDeleteSC(aScKey)} icon='ant-design:delete-outlined' /></div>
        }
//
        var abiPieces = JSON.parse(origAbi);
        var functionsBit = getFunctionsBit(abiPieces);

        // var gotImplementation = false;
        // for (var i = 0; i < abiPieces.length; i++){
        //   var aAbiLine = abiPieces[i];
        //   if (aAbiLine.name === 'implementation'){
        //       gotImplementation = true;
        //     break;
        //   }
        // }

        // var proxyBit = null;
        // if (gotImplementation){

        //   var addSet = smartContracts[aScKey].addSet;
        //   var addSetKeys = Object.keys(addSet);
        //   var firstAddSetKey = addSetKeys[0];

        //   function addProxy(e){
        //     var proxyAddress = window.prompt('Address of proxy', '');
        //     if (proxyAddress){

        //       function postSucceed(thisItem){
        //         setIsLoading(false);
        //         setAmendingWhat(false);
        //         updateProxy(aScKey, firstAddSetKey, thisItem, proxyAddress);
        //       }
              
        //       CoreFns.fetchContractInfo(proxyAddress, chainId,  userID, sessionID, signKey, postSucceed, postFail, chains);
        //     }
        //   }

        //   function clickDeleteProxy(e){
        //     deleteProxy(aScKey, firstAddSetKey);
        //   }


        //   var origProxy = getAddSetItem(aScKey, 'proxy');
        //   if (origProxy){

        //     function clickProxyFunctions(e){
        //       window.alert(getFunctionsBit(JSON.parse(origProxy.abi)));
        //       e.stopPropagation();
        //     }

        //     proxyBit = <div className='col-10' style={{color:'#CCC'}}>
        //       Proxy Address : {origProxy.addr} with <span onClick={clickProxyFunctions} style={{textDecoration:'underline', cursor:'pointer'}}>functions</span>. Click <span style={{textDecoration:'underline', cursor:'pointer'}} onClick={addProxy}>[here]</span> to change proxy address. Click <span style={{textDecoration:'underline', cursor:'pointer'}} onClick={clickDeleteProxy}>[here]</span> to delete proxy</div>

        //   }else{
        //     proxyBit = <div className='col-10' style={{color:'#CCC'}}>This looks like a proxy contract. Click <span style={{textDecoration:'underline', cursor:'pointer'}} onClick={addProxy}>[here]</span> to add proxy address.</div>

        //   }

        // }

                // return handleAnAmending('Replace ' + currAddressShort)


        function clickFunctions(e){
          window.alert(functionsBit);
        }

        var textSet = null;
        var titleSet = null;
        var movementSet = null;

        if (whichSc === aScKey){ 
          titleSet = handleAnAmending(anAddSetName + ' : Amend Contract');
        }else{
          titleSet = <div className='col-12' style={{color, cursor:'pointer', textDecoration:'underline'}} onClick={changeAddSetName(aScKey, anAddSetName)}><b>{anAddSetName}</b></div>
          textSet = <div className='col-12' style={{color:col}}>{txtBit}</div>
          movementSet =  <div className='col-12' ><NormalIcon title='Delete' isBrightWhenLit={true} onClick={clickDeleteSC(aScKey)} icon='ant-design:delete-outlined' /><NormalIcon title='Reload' isBrightWhenLit={true} onClick={function(e){clickCell(aScKey,currAddress)}} icon='zondicons:reload' /><NormalIcon title='Functions' isBrightWhenLit={true} onClick={clickFunctions} icon='material-symbols:function-sharp' /></div>

        }

//
        return (<div className='row' style={{padding:'5px', margin:'5px', paddingBottom:'10px', border:'1px solid white'}}>
             {titleSet}
             {movementSet}
              {textSet}
            </div>)

      


  //
    });

    var botLine;
    if (whichSc === 'load'){
//      
      botLine = handleAnAmending('Load Contract');
                  //
    }else{

      botLine = [<div className='row mb-4'><div className='col-12 mx-auto text-center' >
          <NormalBtn  onClick={function(e){clickCell('load', '')}} title='Load Contract'  backScreen={true}/></div></div>,
        <div className='row mb-4'><div className='col-12 mx-auto text-center' >
          <NormalBtn onClick={clickN} title='Create New Contract' backScreen={true}/>

        </div></div>]
//        

//      
    }
  //


    function clickN(){

      function postOnceOffKey(response){
        var logInStateT = '';
        var logInStateV = '';
        if (logInState){
          logInStateT = logInState.t;
          logInStateV = logInState.v;
        }
        window.open('https://www.cues.sg/contracts/?n=1&lT='+logInStateT+'&lV='+logInStateV+'&rS='+response.v[1].v+'&id='+response.v[0].v);
      }
      ServerComms.fetchSomething({u:'getOnceOffID', sessionID, signKey, userID}, postOnceOffKey);
    }

    function onChange(e){
      setTempAddr(e.target.value);
      uploadErrorMsgs[amendingWhat] = false;
      setUploadErrorMsgs({...uploadErrorMsgs});
    }

    function onInputKeyDown(e){
      // if (e.keyCode === 13){
      //   clickSubmit(tempAddr);
      // }
    }  


    function clickCell(i, addr){
      setTempAddr(addr);
      setWhichSc(i);
      setAmendingWhat(false);
    }


   return (<div className='container'>
          {rows}
        {botLine}
    </div>)


//



}


export default App;
